import { useMemo } from 'react';
import useRequestByHouse from './useRequestByHouse';

const useGetIndicatorsFlat = (addressId) => {
  const { requests = [] } = useRequestByHouse();

  const result = useMemo(() => {
    if (!addressId) return { sumDeadline: 0, sumExpired: 0, sumExcess: 0 };

    const requestFind = requests?.find(
      (request) => request.addressId === addressId
    );

    if (!requestFind) return { sumDeadline: 0, sumExpired: 0, sumExcess: 0 };

    return {
      sumDeadline: requestFind?.sumDeadline || 0,
      sumExpired: requestFind?.sumExpired || 0,
      sumExcess: requestFind?.sumExcess || 0,
    };
  }, [addressId, requests]);

  return result;
};

export default useGetIndicatorsFlat;
